import { toWheelNumber } from "./betPayload";
import { colorOf } from "./helpers";

const isResultRow = (x) =>
  x && typeof x === "object" && ("winningNumber" in x || "winningColor" in x);

// Response me kitni bhi nesting ho, result rows ki array dhundh leta hai
function findList(node, depth = 0) {
  if (depth > 5 || node == null) return null;
  if (typeof node === "string") {
    try {
      return findList(JSON.parse(node), depth + 1);
    } catch {
      return null;
    }
  }
  if (Array.isArray(node)) {
    return node.length === 0 || isResultRow(node[0]) ? node : null;
  }
  if (typeof node === "object") {
    for (const key of Object.keys(node)) {
      const found = findList(node[key], depth + 1);
      if (found) return found;
    }
  }
  return null;
}

function findPagination(node, depth = 0) {
  if (depth > 5 || !node || typeof node !== "object") return null;
  if ("totalPages" in node || "hasMore" in node) return node;
  for (const key of Object.keys(node)) {
    const found = findPagination(node[key], depth + 1);
    if (found) return found;
  }
  return null;
}

export function parseResultsResponse(res) {
  const body = res?.data ?? res ?? {};
  const list = findList(body) || [];
  const pagination = findPagination(body) || {};
  if (process.env.NODE_ENV === "development" && list.length === 0) {
    console.warn("Results: list nahi mili, raw response:", res);
  }
  return { list: sortLatestFirst(list), pagination };
}

// Descending: sabse naya result sabse upar
export const sortLatestFirst = (list) =>
  [...list].sort(
    (a, b) => new Date(b?.createdAt || 0).getTime() - new Date(a?.createdAt || 0).getTime()
  );

// API row -> game history strip item
export function toHistoryItem(row, i = 0) {
  const n = toWheelNumber(String(row?.winningNumber ?? "0"));
  const color = String(row?.winningColor || "").toLowerCase() || colorOf(n);
  return { id: `api-${i}-${row?.createdAt || ""}-${n}`, n, color };
}
